import { Component, OnInit, Input } from '@angular/core';
import { CandidateService } from 'src/app/core/services/candidate.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';

@Component({
  selector: 'app-candidate-send-outreach-email-modal',
  templateUrl: './candidate-send-outreach-email-modal.component.html'
})
export class CandidateSendOutreachEmailModalComponent implements OnInit {

  @Input() modalInstance: any;
  @Input() resolve: any;

  label: any;
  validCandidatesToSendOutreachEmail: any[];
  notValidCandidatesToSendOutreachEmail: any[];
  isSingleCandidateSelected: boolean;
  companyId: any;
  userId: any;
  candidateId: any;
  clientOrBUId: any;
  candidateType: any;
  selectedJobMatchesForOutreach: any[];
  context: any;
  salaryDurationOptions: any;
  jobTypeList: any;
  jobId: any;
  source: string;

  constructor(
    private candidateService: CandidateService,
    private alertsAndNotificationsService: AlertAndNotificationsService
  ) { }

  ngOnInit() {
    this.label = this.resolve.label;
    this.validCandidatesToSendOutreachEmail = this.resolve.validCandidatesToSendOutreachEmail;
    this.notValidCandidatesToSendOutreachEmail = this.resolve.notValidCandidatesToSendOutreachEmail;
    this.isSingleCandidateSelected = this.resolve.isSingleCandidateSelected;
    this.companyId = this.resolve.companyId;
    this.userId = this.resolve.userId;
    this.candidateId = this.resolve.candidateId;
    this.clientOrBUId = this.resolve.clientOrBUId;
    this.candidateType = this.resolve.candidateType;
    this.selectedJobMatchesForOutreach = this.resolve.selectedJobMatchesForOutreach;
    this.context = this.resolve.context;
    this.salaryDurationOptions = this.resolve.salaryDurationOptions;
    this.jobTypeList = this.resolve.jobTypeList;
    this.jobId = this.resolve.jobId;
    this.source = this.resolve.source || 'JOBMATCH_CARD';
  }

  closeModal() {
    this.modalInstance.close({ callbackType: 'cancel' });
  }

  saveCallback() {
    if (this.isSingleCandidateSelected) {
      this.modalInstance.close({ callbackType: 'refresh' });
      return;
    }

    const passedCandidateList: any[] = [];
    this.validCandidatesToSendOutreachEmail.forEach((candidate: any) => {
      if (candidate.selected) {
        passedCandidateList.push({
          id: candidate.candidateId,
          candidateType: candidate.candidateType,
          source: this.source,
          jobIds: [this.jobId],
          jobMatchId: candidate.jobMatchId
        });
      }
    });

    if (passedCandidateList.length > 0) {
      const outreachObject = {
        candidates: passedCandidateList,
        userId: this.userId,
        companyId: this.companyId,
        clientOrBuId: this.clientOrBUId
      };
      this.candidateService.sendOutreachEmail(outreachObject, (data: any) => {
        this.alertsAndNotificationsService.showBannerMessage(data.message, 'success');
        this.modalInstance.close({ callbackType: 'refresh' });
      }, (error: any) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        this.modalInstance.close({ callbackType: 'cancel' });
      });
    } else {
      this.alertsAndNotificationsService.showAlert('No candidates selected', 'Please select atleast one candidate.', 'warning');
    }
  }

  cancelCallback() {
    this.closeModal();
  }
}
